type DateTimeFormatsType = {
  dateTime: Intl.DateTimeFormatOptions;
  date: Intl.DateTimeFormatOptions;
  dateTimeWithTimeZone: Intl.DateTimeFormatOptions;
  dateWithTimeZone: Intl.DateTimeFormatOptions;
  shortTimeWithTimeZone: Intl.DateTimeFormatOptions;
  longTimeWithTimeZone: Intl.DateTimeFormatOptions;
};

export const DATETIME_FORMATS: DateTimeFormatsType = {
  dateTime: {
    dateStyle: 'long',
    timeStyle: 'short',
  },
  date: {
    dateStyle: 'long',
  },
  dateTimeWithTimeZone: {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    timeZoneName: 'short',
  },
  dateWithTimeZone: {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    timeZoneName: 'short',
  },
  shortTimeWithTimeZone: {
    hour: 'numeric',
    minute: 'numeric',
    timeZoneName: 'short',
  },
  longTimeWithTimeZone: {
    hour12: true,
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    timeZoneName: 'short',
  },
};
